import { useContext } from 'react';

import { ConfirmIssueQuotation, QuotationInfoContext } from '../../../shared';

import { FormIssue } from './components';
import { ConfirmIssueRenewal } from '../../../shared/components/ConfirmIssueRenewal';

export const StepFour = () => {
  const { canShowConfirmIssue, canShowConfirmRenewal } = useContext(QuotationInfoContext);

  if (canShowConfirmIssue) {
    return <ConfirmIssueQuotation />;
  }

  if (canShowConfirmRenewal) {
    return <ConfirmIssueRenewal />;
  }

  return <FormIssue />;
};
